import i18n from '@/../i18n';
import { TimeUnitsEnum } from '@/services/dictionaries/TimeUnits';

export const WinnerSelectionTimeOptions = [
    { value: TimeUnitsEnum.Days, label: i18n.t('days') },
    { value: TimeUnitsEnum.Hours, label: i18n.t('hours') },
];

export const TimeOptions = [...WinnerSelectionTimeOptions, { value: TimeUnitsEnum.Minutes, label: i18n.t('minutes') }];
